/**
 * Validation helpers for business information
 */

/**
 * Validates Canadian Business Number (BN)
 * Must be exactly 9 digits
 */
export const isValidBN = (s: string): boolean => {
  return /^\d{9}$/.test(s);
};

/**
 * Validates GST/HST Account Number
 * Format: 123456789RT0001 (9 digits + RT + 4 digits)
 */
export const isValidGSTAcct = (s: string): boolean => {
  return /^\d{9}RT\d{4}$/i.test(s);
};

/**
 * Formats Business Number for display
 */
export const formatBN = (bn: string): string => {
  if (!bn || bn.length !== 9) return bn;
  return `${bn.slice(0, 3)} ${bn.slice(3, 6)} ${bn.slice(6, 9)}`;
};

/**
 * Formats GST/HST Account for display
 */
export const formatGSTAcct = (gst: string): string => {
  if (!gst || !isValidGSTAcct(gst)) return gst;
  const digits = gst.slice(0, 9);
  const suffix = gst.slice(9);
  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)} ${suffix}`;
};

/**
 * Validates full legal name (basic check)
 */
export const isValidFullName = (name: string): boolean => {
  return name.trim().length >= 2 && /^[a-zA-Z\s'-]+$/.test(name.trim());
};
